export const name = {
    'en': 'URL Text file',
    'zh-tw': '網址文字'
};

export const readtextFILE = {
    'en': 'read TEXT file from [url]',
    'zh-tw': '讀取文字檔 [url] '
};

export const readtextFILE2 = {
    'en': '2 read TEXT file from [url]',
    'zh-tw': '2讀取文字檔 [url]'
};

export const writetextFILE = {
    'en': 'write TEXT file [url] data1 [textdata1] data2 [textdata2] data3 [textdata3] data4 [textdata4] data5 [textdata5]',
    'zh-tw': '寫入文字檔 [url] 內容1 [textdata1] 內容2 [textdata2] 內容3 [textdata3] 內容4 [textdata4] 內容5 [textdata5]'
};

export const readFromTEXT = {
    'en': 'TEXT file data',
    'zh-tw': '讀取的文字檔資料'
};

export const textLENGHT = {
    'en': 'length of TEXT file ',
    'zh-tw': '文字檔資料筆數'
};

export const readFromTEXTErr = {
    'en': 'Error: The TEXT file does not exist',
    'zh-tw': '錯誤：文字檔檔案不存在'
};

export const textLENGHTErr = {
    'en': 'Error: Length of the TEXT file is not available',
    'zh-tw': '錯誤：文字檔檔案資料長度不存在'
};

export const readtxtDATA = {
    'en': 'item [n] of the TEXT file [variable]',
    'zh-tw': '文字檔 [variable] 的第 [n] 筆資料'
};

export const openURL = {
    'en': 'open a URL [url]',
    'zh-tw': '瀏覽器開啟網址 [url] '
};
